import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { Badge, Row, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import clsx from "clsx";
import useInterval from "../hooks/useInterval";
import { useModalsDispatch, OPEN_REFERRAL } from "../context/modals";

const DotsContainer = styled.div`
  margin-top: -50px;
  z-index: 1000;
  position: absolute;
  left: 40%;
  transform: translate(-50%, 0px);
`;

function getSlides({ t }) {
  return [
    {
      id: 1,
      Component: (props) => {
        const history = useHistory();

        const handleClick = () => {
          history.push("/");
        };

        return (
          <PromoItem
            title={t("promoTitle")}
            subtitle={t("promoText")}
            imageClass="promo-img-1"
            buttonLabel={t("promoLabel")}
            onClick={handleClick}
          />
        );
      },
    },
    {
      id: 2,
      Component: (props) => {
        const dispatch = useModalsDispatch();

        const toggleRefer = () => {
          dispatch({ type: OPEN_REFERRAL });
        };

        return (
          <PromoItem
            title={t("promoTitle2")}
            subtitle={t("promoText2")}
            imageClass="promo-img-2"
            buttonLabel={t("promoLabel2")}
            onClick={toggleRefer}
          />
        );
      },
    },
    {
      id: 3,
      Component: (props) => {
        const history = useHistory();

        const handleClick = () => {
          history.push("/templates/catalog");
        };

        return (
          <PromoItem
            title={t("promoTitle3")}
            subtitle={t("promoText3")}
            imageClass="promo-img-3"
            buttonLabel={t("promoLabel3")}
            onClick={handleClick}
          />
        );
      },
    },
    {
      id: 4,
      Component: (props) => {
        const history = useHistory();
        const testamentId = "60afb5774ede1b7123cbc33e";

        const handleClick = () => {
          history.push(`/public-templates/${testamentId}/testaments/create`);
        };

        return (
          <PromoItem
            title={t("homePage.testament.0")}
            subtitle={t("homePage.testament.1")}
            imageClass="promo-img-4"
            buttonLabel={t("homePage.testament.2")}
            onClick={handleClick}
          />
        );
      },
    },
  ];
}

function PromoItem({ title, subtitle, buttonLabel, imageClass, onClick }) {
  return (
    <div className="border-0 rounded-md shadow-sm w-100 mb-2 bg-white">
      <Row noGutters>
        <Col lg={7} className="p-4">
          <div className="p-2">
            <h4 className="font-weight-bold mb-4 font-size-32">{title}</h4>
            <p className="text-muted mb-4 font-size-18">{subtitle}</p>
            <span
              className="badge badge-primary rounded pointer mb-3 font-size-18"
              onClick={onClick}
            >
              {buttonLabel}{" "}
            </span>
          </div>
        </Col>
        <Col lg={5} className={`promo-bg ${imageClass} rounded-md-right`}></Col>
      </Row>
    </div>
  );
}

function Promo() {
  const { t } = useTranslation("common");
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = getSlides({ t });
  const changeSlide = (offset) => {
    setCurrentSlide((currentSlide) => {
      const newSlide = (currentSlide + offset) % slides.length;
      if (newSlide < 0) {
        return slides.length - 1;
      }

      return newSlide;
    });
  };

  const next = () => changeSlide(1);
  const previous = () => changeSlide(-1);

  useInterval(() => {
    changeSlide(1);
  }, 7000);

  return (
    <div className="slider position-relative mx-auto mb-4 position-relative w-100 rounded-lg">
      <div className="d-flex px-3">
        {/* <FontAwesomeIcon 
          className="position-absolute text-muted icon-left zindex-top align-self-center lead pointer"
          icon="chevron-left" 
          onClick={previous}
        />
        <FontAwesomeIcon 
          icon="chevron-right" 
          className="position-absolute text-muted icon-right zindex-top align-self-center lead pointer"
          onClick={next}
        /> */}
        {slides.map(
          (slide, i) => currentSlide === i && <slide.Component key={slide.id} />
        )}
      </div>

      <DotsContainer className="text-center">
        <ul className="list-inline">
          {slides.map((slide, i) => (
            <li key={slide.id} className="list-inline-item">
              <FontAwesomeIcon
                icon="circle"
                size="sm"
                style={{ fontSize: 10 }}
                className={clsx(
                  "align-self-center pointer ",
                  currentSlide === i ? "text-accent" : "text-primary"
                )}
                onClick={() => setCurrentSlide(i)}
              />
            </li>
          ))}
        </ul>
      </DotsContainer>
    </div>
  );
}

export default Promo;
